import getItemForMailList from './getItemForMailList';

export default function getItemIdsToShowFromNodeOrThreadIds(
    ids: string[],
    isFirstLevelExpansion: boolean
): string[] {
    const itemIds = [];
    for (const id of ids) {
        const item = getItemForMailList(id, isFirstLevelExpansion);

        // It is possible item is null when it is not in the store or the user
        // is hiding deleted items
        if (item) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (17,26): Object is possibly 'undefined'.
            // @ts-expect-error
            itemIds.push(item.ItemId.Id);
        }
    }
    return itemIds;
}
